import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

export const sendEmail = async (email: string) => {
    const mailtoUrl = `mailto:${email}`

    logEvent(analytics, 'send_email_web', {
        name: 'send email',
        description: 'User sent an email'
    });

    const newWindow = window.open(mailtoUrl);

    if (!newWindow) {
        alert('Unable to open email client.');
    }
}